export default __webpack_public_path__ + "static/media/39t.323b6004.jpg";